
const ShoppingBag = ({ width }) => {
    return (
        <div
            className={`${width} hover:cursor-pointer`}

            role="button"
            aria-label="button"
            aria-description="Click to open shopping cart"

        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 109 108"
            >
                <path
                    fill="#414042"
                    d="M64.873 107.582H.513V29.583H68.42V48.7h-7.095V36.674H7.608v63.817h57.265v7.091z"
                ></path>
                <path
                    fill="#414042"
                    d="M108.961 107.582H41.055v-47.61h67.906v47.61zm-60.812-7.091h53.718V67.063H48.149v33.428zM53.217 43.258h-7.094V18.74c0-6.423-5.23-11.65-11.656-11.65-6.427 0-11.655 5.227-11.655 11.65v24.518h-7.095V18.74C15.717 8.407 24.128 0 34.467 0c10.34 0 18.75 8.407 18.75 18.74v24.518z"
                ></path>
                <path
                    fill="#414042"
                    d="M90.718 73.647h-7.094V55.413c0-4.747-3.865-8.61-8.615-8.61s-8.615 3.863-8.615 8.61v18.234h-7.095V55.413c0-8.657 7.047-15.7 15.71-15.7 8.662 0 15.71 7.043 15.71 15.7v18.234z"
                ></path>
            </svg>
        </div>
    )
}

export default ShoppingBag
